var map = {
	"./404.vue": [
		"8cdb",
		"chunk-2d0e95df"
	],
	"./Biblioteca.vue": [
		"4860",
		"chunk-3a2184ee"
	],
	"./Busca.vue": [
		"444e",
		"chunk-b511c202"
	],
	"./Categoria.vue": [
		"0c3d",
		"chunk-6b8d1e58"
	],
	"./Categorias.vue": [
		"f1c1",
		"chunk-87281e6e"
	],
	"./Edicao.vue": [
		"91d5",
		"chunk-168b0720"
	],
	"./EdicaoImage.vue": [
		"4ee6",
		"chunk-4440f0b0",
		"chunk-a626379a"
	],
	"./EdicaoPages.vue": [
		"60f6",
		"chunk-4440f0b0",
		"chunk-80725060"
	],
	"./EdicaoVideo.vue": [
		"4358",
		"chunk-1798b2de"
	],
	"./Explorar.vue": [
		"7b70",
		"chunk-1e173842"
	],
	"./Faq.vue": [
		"10c2",
		"chunk-455057a5"
	],
	"./Favoritos.vue": [
		"5628",
		"chunk-59474b20"
	],
	"./Home.vue": [
		"bb51",
		"chunk-79fa1b56"
	],
	"./Integracao.vue": [
		"d956",
		"chunk-6b6ad80d"
	],
	"./Layout.vue": [
		"88e9",
		"chunk-4f5d9ad8"
	],
	"./Login.vue": [
		"a55b",
		"chunk-789bbafc"
	],
	"./Logout.vue": [
		"c100",
		"chunk-2d215fa4"
	],
	"./Perfil.vue": [
		"68f9",
		"chunk-86501348"
	],
	"./PerfilCancel.vue": [
		"3ea4",
		"chunk-a594bba8"
	],
	"./PerfilEditar.vue": [
		"c843",
		"chunk-9b8e65ec"
	],
	"./PerfilFaq.vue": [
		"9130",
		"chunk-ac7ff776"
	],
	"./PerfilInfantil.vue": [
		"7e0b",
		"chunk-160111d9"
	],
	"./PerfilPolitica.vue": [
		"1abb",
		"chunk-4bae97da"
	],
	"./PerfilTermos.vue": [
		"be6b",
		"chunk-0865540e"
	],
	"./Playlist.vue": [
		"2059",
		"chunk-df9055c6"
	],
	"./Politica.vue": [
		"40a9",
		"chunk-38d2d20a"
	],
	"./Subscription.vue": [
		"d7e2",
		"chunk-5e80b2b2"
	],
	"./Termos.vue": [
		"f2e1",
		"chunk-2bc59708"
	],
	"./Titulo.vue": [
		"4dd7",
		"chunk-e4e36c82"
	],
	"./Welcome.vue": [
		"eec5",
		"chunk-bd083ca2"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;